import Vue from "vue";
import VueI18n from "vue-i18n";

import {defaultLocale, localeOptions} from './../constants/config';

// Localisation language list
import en from './../locales/en.json';
import bg from './../locales/bg.json';
import fr from './../locales/fr.json';
import sk from './../locales/sk.json';
import sl from './../locales/sl.json';

Vue.use(VueI18n);

const messages = {
	en: {
		message: en
	},
	bg: {
		message: bg
	},
	fr: {
		message: fr
	},
	sk: {
		message: sk
	},
	sl: {
		message: sl
	}
}

const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;

const i18n = new VueI18n({
	locale: locale,
	fallbackLocale: 'en',
	messages,
	silentTranslationWarn: true
});

export default i18n;